function text(value) {
  return String(value ?? '').trim();
}

function stripVisibleBossNumber(value) {
  return text(value)
    .replace(/^\s*\d+\s*보스\s*[-·:|/]?\s*/i, '')
    .replace(/^\s*보스\s*\d+\s*[-·:|/]?\s*/i, '')
    .replace(/^\s*BOSS\s*\d+\s*[-·:|/]?\s*/i, '')
    .trim();
}

export function bossDisplayName(boss = {}, fallbackBossNo = null) {
  const rawName = text(boss?.bossName ?? boss?.boss_name ?? boss?.name);
  const name = stripVisibleBossNumber(rawName);
  if (name && !/^보스$/i.test(name) && !/^BOSS$/i.test(name)) return name;

  void fallbackBossNo;
  return '보스';
}
